import { render, staticRenderFns } from "./DetailCampusSecondScreen.vue?vue&type=template&id=fe9aafd0"
import script from "./DetailCampusSecondScreen.vue?vue&type=script&lang=js"
export * from "./DetailCampusSecondScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports